import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class SurveysListRow {
  static props = ['href', 'name', 'status', 'isPublic', 'createdAt', 'createdBy'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.name }}
    td.pr-4 {{ Props.status }}
    td.pr-4 {{ Props.isPublic }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.createdBy }}
  `;
}

export class SurveysList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/surveys/create"] Create survey
    <PageTitle title="Surveys">
    table.resource-table[data-empty-title="No surveys yet" data-empty-description="Create a survey to gather feedback from your users." data-empty-action="Create survey" data-empty-href="/surveys/create"]
      thead
        th Name
        th.pr-4 Status
        th.pr-4 Public
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#surveys-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('surveys'))
      .then(response => {
        appendDataToListTable('#surveys-list-rows', response.data, SurveysListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#surveys-list-rows', error, 'Surveys'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.name}`,
      name: item.name,
      status: item.status || '',
      isPublic: item.isPublic ? 'Yes' : 'No',
      createdAt: Util.formatDate(item.createdAt),
      createdBy: item.createdBy || ''
    };
  }
}
